/// <amd-module name="TFS/TeamPanel/TeamPanelIcon/TeamPanelIcon" />
import * as React from "react";
import * as TeamPanelResources from "TFS/TeamPanel/Resources";
import { WrappedComponent } from "VSS/Platform/Layout";
import { Button } from "VSSUI/Button";
import { Icon } from "VSSUI/Icon";

export interface ITeamPanelIconButtonProps {
    projectName: string;
    projectId: string;
    teamId: string;
    teamName: string;
    showText?: boolean;
}

export interface ITeamPanelIconButtonState {
    isPanelOpen: boolean;
}

export class TeamPanelIconButton extends React.Component<ITeamPanelIconButtonProps, ITeamPanelIconButtonState> {
    constructor(props: ITeamPanelIconButtonProps) {
        super(props);

        this.state = {
            isPanelOpen: false
        };
    }

    public render(): JSX.Element {
        const iconProps = {
            iconName: "People"
        };

        return (
            this.props.showText ? (
                <span>
                    <Icon iconName={"People"} className="icon-margin"/>
                    <Button
                        text={this.props.teamName}
                        subtle={true}
                        className="team-panel-button"
                        ariaLabel={TeamPanelResources.ShowTeamProfile}
                        onClick={this._onClick}
                        tooltipProps={{ text: TeamPanelResources.ShowTeamProfile }}
                    />
                    {this.state.isPanelOpen && (
                        <WrappedComponent
                            wrappedType="legacy"
                            dependencies={["ms.vss-web.legacy-content"]}
                            wrappedProps={{
                                componentType: "teamPanel",
                                modules: ["Presentation/Scripts/TFS/TeamPanel/TeamPanel"],
                                teamPanelContext: this.props,
                                onDismiss: this._onTeamPanelDismiss
                            }}
                        />
                    )}
                </span>
            ) : (
                <div>
                    <Button
                        subtle={true}
                        className="team-panel-button"
                        ariaLabel={TeamPanelResources.ShowTeamProfile}
                        onClick={this._onClick}
                        iconProps={iconProps}
                        tooltipProps={{ text: TeamPanelResources.ShowTeamProfile }}
                    />
                    {this.state.isPanelOpen && (
                        <WrappedComponent
                            wrappedType="legacy"
                            dependencies={["ms.vss-web.legacy-content"]}
                            wrappedProps={{
                                componentType: "teamPanel",
                                modules: ["Presentation/Scripts/TFS/TeamPanel/TeamPanel"],
                                teamPanelContext: this.props,
                                onDismiss: this._onTeamPanelDismiss
                            }}
                        />
                    )}
                </div>
            )
        );
    }
    private _onTeamPanelDismiss = () => {
        this.setState({ isPanelOpen: false });
    };

    private _onClick = () => {
        this.setState({ isPanelOpen: true });
    };
}
